import { render, staticRenderFns } from "./materialDeviceParamManage.vue?vue&type=template&id=5c78da76&scoped=true"
import script from "./materialDeviceParamManage.vue?vue&type=script&lang=js"
export * from "./materialDeviceParamManage.vue?vue&type=script&lang=js"
import style0 from "./materialDeviceParamManage.vue?vue&type=style&index=0&id=5c78da76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c78da76",
  null
  
)

export default component.exports